import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { H1 } from 'foundations-components/transitional/components/H1';
import { View } from 'foundations-components/components/View';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import { UsageScreenProvider } from 'marketplace-ui-tracking';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { Paths } from '../../constants/paths';
import { Subscreens } from '../../constants/usage';
import { StorefrontBreadcrumbs } from '../../navigation/components/StorefrontBreadcrumbs';
import { StorefrontBreadcrumbStructuredData } from '../../navigation/components/StorefrontBreadcrumbsStructuredData';
import { StorefrontNav } from '../../navigation/components/StorefrontNav';
import { SearchBar } from '../../search-bar/components/SearchBar';
import { ManageBuildDropdowns } from './ManageBuildDropdowns';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function UnifiedHeader({
  dataTestId = 'unified-header',
  backBreadcrumb,
  pathKey,
  productType,
  title,
  subtitle,
  isHomePage = false
}) {
  const breadcrumbProps = {
    backBreadcrumb,
    pathKey,
    productType,
    title
  };
  const {
    isMobile
  } = useResponsiveProps({
    isMobile: {
      xs: true,
      sm: false
    }
  });
  return /*#__PURE__*/_jsxs(UsageScreenProvider, {
    subscreen: Subscreens.STOREFRONT_NAVIGATION,
    children: [!isHomePage && /*#__PURE__*/_jsx(StorefrontBreadcrumbStructuredData, Object.assign({}, breadcrumbProps)), isMobile ? /*#__PURE__*/_jsxs(Flex, {
      "data-test-id": dataTestId,
      flexDirection: "column",
      paddingBlock: "1100",
      position: "relative",
      gap: "500",
      children: [isHomePage ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(UIRouterLink, {
          to: Paths.HOME,
          use: "unstyled",
          children: /*#__PURE__*/_jsx(H1, {
            "aria-level": 1,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplaceStorefront.headers.title"
            })
          })
        }), /*#__PURE__*/_jsx(ManageBuildDropdowns, {}), /*#__PURE__*/_jsx(StorefrontNav, {})]
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(StorefrontBreadcrumbs, Object.assign({}, breadcrumbProps)), /*#__PURE__*/_jsx(H1, {
          "aria-level": 1,
          children: title
        }), subtitle && /*#__PURE__*/_jsx(Text, {
          color: "text-core-subtle",
          children: subtitle
        }), /*#__PURE__*/_jsx(ManageBuildDropdowns, {})]
      }), /*#__PURE__*/_jsx(View, {
        alignSelf: "stretch",
        children: /*#__PURE__*/_jsx(SearchBar, {
          showTabs: true
        })
      })]
    }) : /*#__PURE__*/_jsxs(Flex, {
      "data-test-id": dataTestId,
      flexDirection: "column",
      paddingBlock: "1100",
      position: "relative",
      minBlockSize: "200px",
      children: [/*#__PURE__*/_jsxs(Flex, {
        justifyContent: "space-between",
        alignItems: "center",
        marginBlockEnd: "600",
        minBlockSize: "40px",
        children: [/*#__PURE__*/_jsx(View, {
          flex: "1",
          children: isHomePage ? /*#__PURE__*/_jsx(UIRouterLink, {
            to: Paths.HOME,
            use: "unstyled",
            children: /*#__PURE__*/_jsx(H1, {
              "aria-level": 1,
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "marketplaceStorefront.headers.title"
              })
            })
          }) : /*#__PURE__*/_jsx(StorefrontBreadcrumbs, Object.assign({}, breadcrumbProps))
        }), /*#__PURE__*/_jsx(ManageBuildDropdowns, {})]
      }), /*#__PURE__*/_jsxs(Flex, {
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        columnGap: "1000",
        rowGap: "500",
        minBlockSize: "40px",
        children: [/*#__PURE__*/_jsx(Flex, {
          alignItems: "center",
          minBlockSize: "40px",
          flex: isHomePage ? '0 1 auto' : '1 1 0%',
          children: isHomePage ? /*#__PURE__*/_jsx(StorefrontNav, {}) : /*#__PURE__*/_jsxs(View, {
            minInlineSize: "400px",
            children: [/*#__PURE__*/_jsx(H1, {
              "aria-level": 1,
              children: title
            }), subtitle && /*#__PURE__*/_jsx(Text, {
              color: "text-core-subtle",
              typography: "body-100",
              children: subtitle
            })]
          })
        }), /*#__PURE__*/_jsx(Flex, {
          alignItems: "center",
          flexGrow: 1,
          minBlockSize: "40px",
          minInlineSize: "400px",
          maxInlineSize: "600px",
          children: /*#__PURE__*/_jsx(SearchBar, {
            showTabs: true
          })
        })]
      })]
    })]
  });
}